"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateEntitlementDiscountDto = exports.EntitlementDiscountDto = exports.EntitlementDiscountGroupDto = exports.ItemDiscountDto = exports.RemoveDiscountsDto = exports.RemoveDiscountDto = exports.SetDiscountsDto = exports.SetDiscountDto = exports.UpdateDiscountsDto = exports.CreateDiscountsDto = exports.UpdateDiscountDto = exports.CreateDiscountDto = exports.GetDiscountsDto = exports.SimpleDiscountDto = exports.DiscountDto = exports.DiscountRelatedProductsDto = exports.DiscountRelatedEntitlementsDto = exports.DiscountRelatedMembershipsDto = exports.DiscountRelatedProgramsDto = exports.DiscountRelatedProgramTypesDto = exports.DiscountRelatedProductIdsDto = void 0;
const general_dto_1 = require("../../dto/general.dto");
const organization_dto_1 = require("../../organization/dto/organization.dto");
const program_enums_1 = require("../../programs/types/enums/program.enums");
const enums_service_1 = require("../../services/enums.service");
const discount_enums_1 = require("../types/enums/discount.enums");
class DiscountRelatedProductIdsDto {
}
exports.DiscountRelatedProductIdsDto = DiscountRelatedProductIdsDto;
class DiscountRelatedProgramTypesDto {
}
exports.DiscountRelatedProgramTypesDto = DiscountRelatedProgramTypesDto;
program_enums_1.ProgramTypesEnum.CLASS, program_enums_1.ProgramTypesEnum.CLINIC, program_enums_1.ProgramTypesEnum.CAMP, program_enums_1.ProgramTypesEnum.CLUB_TEAM, program_enums_1.ProgramTypesEnum.LESSON;
class DiscountRelatedProgramsDto {
}
exports.DiscountRelatedProgramsDto = DiscountRelatedProgramsDto;
class DiscountRelatedMembershipsDto {
}
exports.DiscountRelatedMembershipsDto = DiscountRelatedMembershipsDto;
enums_service_1.MembershipTypeEnum.FIXED, enums_service_1.MembershipTypeEnum.ROLLING;
class DiscountRelatedEntitlementsDto {
}
exports.DiscountRelatedEntitlementsDto = DiscountRelatedEntitlementsDto;
class DiscountRelatedProductsDto {
}
exports.DiscountRelatedProductsDto = DiscountRelatedProductsDto;
class DiscountFieldsDto {
}
class DiscountDto extends DiscountFieldsDto {
}
exports.DiscountDto = DiscountDto;
class SimpleDiscountDto extends organization_dto_1.OrganizationBaseEntityDto {
}
exports.SimpleDiscountDto = SimpleDiscountDto;
class GetDiscountsDto extends general_dto_1.PaginationQuery {
}
exports.GetDiscountsDto = GetDiscountsDto;
class CreateDiscountDto extends DiscountFieldsDto {
}
exports.CreateDiscountDto = CreateDiscountDto;
class UpdateDiscountDto {
}
exports.UpdateDiscountDto = UpdateDiscountDto;
class CreateDiscountsDto {
}
exports.CreateDiscountsDto = CreateDiscountsDto;
class UpdateDiscountsDto {
}
exports.UpdateDiscountsDto = UpdateDiscountsDto;
class SetDiscountDto {
}
exports.SetDiscountDto = SetDiscountDto;
class SetDiscountsDto {
}
exports.SetDiscountsDto = SetDiscountsDto;
class RemoveDiscountDto {
}
exports.RemoveDiscountDto = RemoveDiscountDto;
class RemoveDiscountsDto {
}
exports.RemoveDiscountsDto = RemoveDiscountsDto;
class ItemDiscountDto extends organization_dto_1.OrganizationBaseEntityDto {
}
exports.ItemDiscountDto = ItemDiscountDto;
class EntitlementDiscountGroupDto {
}
exports.EntitlementDiscountGroupDto = EntitlementDiscountGroupDto;
class EntitlementDiscountDto extends general_dto_1.IdDto {
}
exports.EntitlementDiscountDto = EntitlementDiscountDto;
class CreateEntitlementDiscountDto extends CreateDiscountDto {
    constructor() {
        super(...arguments);
        // set default value
        this.type = discount_enums_1.DiscountTypeEnum.ENTITLEMENT_GROUP;
    }
}
exports.CreateEntitlementDiscountDto = CreateEntitlementDiscountDto;
//# sourceMappingURL=discount.dto.js.map